import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/hasil-usg", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/hasil-usg/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/hasil-usg`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/hasil-usg/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDpjp(id: number, data) {
  const response = await http.putData(`/hasil-usg/${id}/sign-dpjp`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/hasil-usg/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/hasil-usg/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  signDpjp,
  destroy,
  print
};
